module.exports = __webpack_public_path__ + "static/media/YF107_3.df8a645f.jpg";